module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.data ? _vm.config.data.auditContent : false),
      expression: "config.data ? config.data.auditContent : false"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalNo",
      "label": _vm.$t('app_terNo'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "",
      "size": "small"
    },
    model: {
      value: (_vm.showPic.value),
      callback: function($$v) {
        _vm.$set(_vm.showPic, "value", $$v)
      },
      expression: "showPic.value"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "src": _vm.showPic.data
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReason),
      expression: "isShowReason"
    }]
  }, [_c('el-alert', {
    staticStyle: {
      "display": "-webkit-flex",
      "margin": "0 0 5px 0"
    },
    attrs: {
      "title": _vm.reason,
      "type": "error",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filename'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_filedesc'),
      "prop": ""
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc", $$v)
      },
      expression: "form.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_version'),
      "prop": ""
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.ver),
      callback: function($$v) {
        _vm.$set(_vm.form, "ver", $$v)
      },
      expression: "form.ver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isbase),
      expression: "isbase"
    }],
    attrs: {
      "label": _vm.$t('app_preversion'),
      "prop": _vm.isbase ? _vm.bver : ''
    }
  }, [_c('el-input', {
    staticClass: "aeMg",
    model: {
      value: (_vm.form.bver),
      callback: function($$v) {
        _vm.$set(_vm.form, "bver", $$v)
      },
      expression: "form.bver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "label": _vm.$t('app_ulfile'),
      "prop": "url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl
    }
  }, [_c('span', [(_vm.ulinfo.index === 0) ? _c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "22px",
      "color": "#48576A"
    }
  }, [_c('i', {
    class: _vm.ulinfo.icons[_vm.ulinfo.index],
    style: (_vm.tipColor)
  }), _vm._v(" "), _c('el-col', [_c('el-row', {
    staticStyle: {
      "margin-top": "-8px"
    }
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_filename')) + ": " + _vm._s(_vm.form.fname))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileSize')) + ": " + _vm._s(_vm.form.size / 1024) + "KB")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "26px"
    }
  }, [_vm._v("MD5: " + _vm._s(_vm.form.md5))]), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clreul')))])], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ulinfo.index === 0),
      expression: "ulinfo.index === 0"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.ulinfo.tip))])])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_useDis'),
      "prop": "mech"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none",
      "margin-top": "30px"
    },
    attrs: {
      "label": _vm.$t('app_testInstall')
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushInstall
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pushInstall')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 3),
      expression: "config.type === 3"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_isPass')
    }
  }, [_c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_pass')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio aeMg",
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.radio),
      callback: function($$v) {
        _vm.radio = $$v
      },
      expression: "radio"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ban')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.radio === '2'),
      expression: "radio === '2'"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": _vm.$t('app_banReason')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkDesc),
      expression: "checkDesc"
    }],
    staticStyle: {
      "width": "100%",
      "height": "60px",
      "float": "left"
    },
    domProps: {
      "value": (_vm.checkDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.checkDesc = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.type === 2),
      expression: "config.type === 2"
    }],
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "label": ""
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lcNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_upload') + 'launcher'))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5987d0a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nonintelligent/app/edit.vue
// module id = 1047
// module chunks = 0